import { HelpArticleItems } from "./help-article-item";
import { HelpContainer } from "../help-shared/help-container";
import { HelpRelatedItems } from "../help-shared/related-item.jsx";
import { normalizeArticles } from "../functions/normalize-helper.jsx";
import { ThemedTiles } from "../functions/tile.jsx";
import { HelpItemType } from "../constants.js";

function HelpArticle(props) {
    const getArticles = () => {
        if (!props.Articles || props.Articles.length === 0) return null;
        return <ThemedTiles Visible Theme={props.Theme} Tiles={normalizeArticles(props.Articles)} OnClick={(tile) => props.OnClick(tile.Id, HelpItemType.Article)} />;
    };

    const handleClickRelated = (id, type) => {
        if (typeof props.OnClickRelated === "function") {
            return props.OnClickRelated(id, type ?? HelpItemType.Article);
        }
        props.OnClick(id, type ?? HelpItemType.Article);
    };

    if (props.Visible !== undefined && props.Visible !== true) {
        return null;
    }

    return (
        <HelpContainer
            Theme={props.Theme}
            Name={props.Name}
            Description={props.Description}
            ShowAiChat={props.ShowAiChat}
            OpenAiChatSidebar={props.OpenAiChatSidebar}
            ProductName={props.ProductName}
            CopyState={props.CopyState}>
            {getArticles()}
            <HelpArticleItems
                Items={props.Items}
                Theme={props.Theme}
                BaseUrl={props.BaseUrl} />
            <HelpRelatedItems
                Items={normalizeArticles(props.RelatedArticles)}
                Theme={props.Theme}
                OnClick={handleClickRelated} />
        </HelpContainer>
    );
}

export { HelpArticle };